import { DomainKeyEnum } from "./DomainKeyEnum";

type EntityDomainMapping = Record<string, Record<string, DomainKeyEnum>>;

export const domainMapping: EntityDomainMapping = {
    offer: {
        status: DomainKeyEnum.MarketingActionStatus, // MarketingActionStatusDomain,
        startDate: DomainKeyEnum.Date,
        endDate: DomainKeyEnum.Date,
        startTime: DomainKeyEnum.Time,
        endTime: DomainKeyEnum.Time,
        days: DomainKeyEnum.Days,
        typeId: DomainKeyEnum.IdName,
        audienceId: DomainKeyEnum.IdName,
        recurrenceId: DomainKeyEnum.IdName,
        isSpecial: DomainKeyEnum.Boolean,
        preorder: DomainKeyEnum.Boolean,
    },
    offerSlot: {
        status: DomainKeyEnum.MarketingActionStatus,
        serviceTime: DomainKeyEnum.ServiceTime,
        publicationStartAt: DomainKeyEnum.DateTime,
        publicationEndAt: DomainKeyEnum.DateTime,
        isSpecial: DomainKeyEnum.Boolean,
        computationStartAt: DomainKeyEnum.DateTime,
        computationEndAt: DomainKeyEnum.DateTime,
    },
    sponsoredAd: {
        status: DomainKeyEnum.MarketingActionStatus,
        startDate: DomainKeyEnum.Date,
        endDate: DomainKeyEnum.Date,
        startTime: DomainKeyEnum.Time,
        endTime: DomainKeyEnum.Time,
        days: DomainKeyEnum.Days,
        bid: DomainKeyEnum.Amount,
        slotBudget: DomainKeyEnum.Amount,
        isSpecial: DomainKeyEnum.Boolean,
        audienceId: DomainKeyEnum.IdName,
        recurrenceId: DomainKeyEnum.IdName,
    },
    sponsoredAdSlot: {
        status: DomainKeyEnum.MarketingActionStatus,
        serviceTime: DomainKeyEnum.ServiceTime,
        publicationStartAt: DomainKeyEnum.DateTime,
        publicationEndAt: DomainKeyEnum.DateTime,
        isSpecial: DomainKeyEnum.Boolean,
        computationStartAt: DomainKeyEnum.DateTime,
        computationEndAt: DomainKeyEnum.DateTime,
    },
};
